import axios from 'axios';
import { userManager } from '@libs/oidc';

import {
  cancelQueueRequestInterceptor,
  cancelQueueResponseInterceptor,
} from './interceptors/canceller';
import { runtimeValidate } from './interceptors/zod';
import { mockInterceptor } from './interceptors/mock';
import { parseErrorMessages, parseUrlParams } from './interceptors/parser';
import { resolveToken, renewToken, revokeSession } from './interceptors/token';
import { objectToQueryString } from './utils';

const instance = axios.create({
  paramsSerializer: {
    serialize(params) {
      // Turn params to an instance of the JavaScript's built-in URLSearchParams
      return objectToQueryString(params);
    },
  },
});

instance.defaults.headers.common['Accept-Language'] = 'fa';

instance.interceptors.response.use(undefined, revokeSession);
instance.interceptors.response.use(undefined, renewToken(instance));
instance.interceptors.response.use(runtimeValidate);
instance.interceptors.response.use(cancelQueueResponseInterceptor);

instance.interceptors.request.use(mockInterceptor);
instance.interceptors.request.use(parseUrlParams);
instance.interceptors.request.use(cancelQueueRequestInterceptor);
instance.interceptors.request.use(
  resolveToken(() =>
    userManager.getUser().then((user) => {
      return user?.access_token;
    })
  )
);
instance.interceptors.response.use(undefined, parseErrorMessages);

export * from 'axios';
export default instance;
export { default as cancelQueue } from './cancelQueue';
